import SampleMutations from "./sample/sample.mutation";
import SampleQueries from "./sample/sample.query";

const SampleServices = {
  ...SampleQueries,
  ...SampleMutations,
};

export default SampleServices;
